import React, { useContext, useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { makeStyles } from 'tss-react/mui';
import Paper from "@mui/material/Paper";
import SearchIcon from "@mui/icons-material/Search";
import InputBase from "@mui/material/InputBase";
import MoveToInboxIcon from "@mui/icons-material/MoveToInbox";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import ArchiveIcon from "@mui/icons-material/Archive";
import FormControlLabel from "@mui/material/FormControlLabel";
import SelectConection from "../../components/SelectConection";
import Grid from '@mui/material/Grid';
import NewTicketModal from "../NewTicketModal";
import TicketsList from "../TicketsListCustom";
import TabPanel from "../TabPanel";
import { i18n } from "../../translate/i18n";
import { AuthContext } from "../../context/Auth/AuthContext";
import TicketsQueueSelect from "../TicketsQueueSelect";
import { TagsFilter } from "../TagsFilter";
import { UsersFilter } from "../UsersFilter";
import Alert from '@mui/material/Alert';
import { WhatsApp, PushPin } from "@mui/icons-material";
import FilterListIcon from '@mui/icons-material/FilterList';
import { Button, Chip, Collapse, Box, Typography } from "@mui/material";
import { IconButton } from "@mui/material";
import MarkunreadIcon from "@mui/icons-material/Markunread";
import ContactIcon from '@mui/icons-material/Contacts';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatOutlined';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import FeedbackIcon from '@mui/icons-material/Feedback';
import RedditIcon from '@mui/icons-material/Reddit';
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import SelectStatusContact from "../SelectStatusContact";
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import Switch from "@mui/material/Switch";
import FormatLineSpacingIcon from '@mui/icons-material/FormatLineSpacing';
import { ArrowDownward, ArrowUpward } from '@mui/icons-material';
import { Tabs, Tab, Badge, Tooltip, MenuItem, Select, Fab, FormControl } from "@mui/material";
import api from "../../services/api";
import { toast } from "../../services/toast";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

import { withStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  ticketsWrapper: {
    position: "relative",
    display: "flex",
    height: "100%",
    flexDirection: "column",
    overflow: "hidden",
    borderRadius: 0,
    borderLeft: "none",
  },
  tabsHeader: {
    flex: "none",
    backgroundColor: theme.palette.mode === "light" ? "#eee" : "#20252c",
  },
  settingsIcon: {
    alignSelf: "center",
    marginLeft: "auto",
    padding: 8,
  },
  tab: {
    minWidth: 120,
    width: 120,
  },
  select: {
    fontSize: 13,
    padding: "4px 8px",
    background: "transparent",
    color: theme.palette.text.primary,
    display: "flex",
    alignItems: "center",
    "& .MuiSelect-select": {
      overflow: "visible !important",
    },
  },
  ticketOptionsBox: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    background: theme.palette.mode === "light" ? "#fafafa" : "#20252c",
    padding: theme.spacing(1),
  },
  badgeContainer: {
    display: "flex",
    alignItems: "center",
    gap: 15,
  },
  smallTab: {
    minWidth: 50,
    width: 50,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  expandableTab: {
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: 0,
    minWidth: 64,
    [theme.breakpoints.up('sm')]: {
      minWidth: 100,
      padding: '6px 16px',
    },
  },
  tabLabelContent: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
  },
  tabLabelText: {
    display: 'none',
    fontSize: 13,
    textTransform: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'inline',
    },
  },
  serachInputWrapper: {
    flex: 1,
    background: "#fff",
    display: "flex",
    borderRadius: 40,
    padding: 4,
    marginTop: '3%',
    marginRight: theme.spacing(1),
  },
  searchIcon: {
    color: "grey",
    marginLeft: 6,
    marginRight: 6,
    alignSelf: "center",
  },
  badge: {
    display: 'inline-flex',
    '& .MuiBadge-badge': {
      fontSize: 11,
      fontWeight: 600,
      minWidth: 20,
      height: 20,
      padding: '0 5px',
    },
  },
  tabIcon: {
    fontSize: 24,
  },
  show: {
    display: "block",
  },
  hide: {
    display: "none !important",
  },
  searchInputWrapper: {
    position: 'relative',
    width: '100%',
  },
  searchInputContainer: {
    display: 'flex',
    alignItems: 'center',
    padding: '5px 5px',
    borderRadius: 5,
    backgroundColor: theme.palette.mode === "light" ? '#f3f3f3' : 'rgba(255,255,255,0.06)',

  },
  searchInput: {
    flex: 1,
    paddingLeft: '10px',
    fontSize: 13,
    border: 'none',
    outline: 'none',
    background: 'transparent',
    color: theme.palette.text.primary,
    '&::placeholder': {
      color: theme.palette.text.secondary,
    },
  },
  iconButton: {
    padding: 5,
    color: theme.palette.text.secondary,
  },
  fab: {
    position: "absolute",
    bottom: 20,
    right: 20,
    zIndex: 3,
    backgroundColor: "#25d366",
    color: "#fff",
    boxShadow: "0 4px 12px rgba(37, 211, 102, 0.45)",
    "&:hover": {
      backgroundColor: "#20bd5a",
    },
  },
}));

const TicketsManagerTabs = () => {
  const { classes } = useStyles();
  const navigate = useNavigate();

  const [searchParam, setSearchParam] = useState("");
  const [searchMessage, setSearchMessage] = useState("");
  const [searchMode, setSearchMode] = useState("contact");

  const [tab, setTab] = useState("open");
  const [tabOpen, setTabOpen] = useState("open");
  const [newTicketModalOpen, setNewTicketModalOpen] = useState(false);
  const [showAllTickets, setShowAllTickets] = useState("false");
  const searchInputRef = useRef();
  const { user } = useContext(AuthContext);
  const { profile } = user;

  const [openCountFavorite, setOpenCountFavorite] = useState(0);
  const [openCount, setOpenCount] = useState(0);
  const [pendingCount, setPendingCount] = useState(0);
  const [botCount, setBotCount] = useState(0);

  useEffect(() => {
    if (tab === "bot" && botCount === 0) {
      setTab("open");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [botCount, tab]);

  const [orderByRecent, setOrderByRecent] = useState(true);

  const [closedCount, setClosedCount] = useState(0);
  const userQueueIds = user.queues.map((q) => q.id);
  const [selectedQueueIds, setSelectedQueueIds] = useState(userQueueIds || []);

  const [selectedStatusId, setSelectedStatusId] = useState(null);

  const [selectedTags, setSelectedTags] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);

  const [whatsappId, setWhatsappId] = useState('');
  const [showUnread, setShowUnread] = useState(false);
  const [showFilters, setShowFilters] = useState(false);

  const [selectedCampaign, setSelectedCampaign] = useState('');
  const [campaignCount, setCampaignCount] = useState(0);

  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const campana = searchParams.get("campaign");
    if (!campana) return;

    setSelectedCampaign(campana);
    setShowFilters(true);

    searchParams.delete("campaign");
    setSearchParams(searchParams, { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [exporting, setExporting] = useState(false);

  const handleExport = async () => {
    setExporting(true);
    try {
      const esCerrados = tab === "closed";

      const { data, headers } = await api.get("/tickets/export", {
        responseType: "blob",
        params: {
          status: esCerrados ? "closed" : tabOpen,
          showAll: esCerrados ? "true" : showAllTickets,
          queueIds: JSON.stringify(selectedQueueIds),
          tags: JSON.stringify(selectedTags),
          ...(esCerrados
            ? {
                usersLast: JSON.stringify(selectedUsers),
                whatsappIdLast: whatsappId || undefined
              }
            : {
                users: JSON.stringify(selectedUsers),
                whatsappId: whatsappId || undefined
              }),
          statusId: selectedStatusId || undefined,
          searchParam: searchParam || undefined,
          adReferralSourceId: selectedCampaign || undefined,
          orderByRecent
        }
      });

      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `tickets-${new Date().toISOString().slice(0, 10)}.xlsx`
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      if (headers["x-export-truncated"] === "1") {
        toast.warning(
          `Se exportaron ${headers["x-export-count"]} de ${headers["x-export-total"]} tickets. Afina los filtros para incluir el resto.`,
          { duration: 10000 }
        );
      } else {
        toast.success(`${headers["x-export-count"] || ""} tickets exportados.`);
      }
    } catch (e) {
      toast.error("No se pudo exportar la lista.");
    } finally {
      setExporting(false);
    }
  };
  const [campaignOptions, setCampaignOptions] = useState([]);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const { data } = await api.get("/ticket/ad-referrals");
        if (active) setCampaignOptions(Array.isArray(data) ? data : []);
      } catch (err) {
        if (active) setCampaignOptions([]);
      }
    })();
    return () => {
      active = false;
    };
  }, []);

  let searchTimeout;

  const toggleFilters = () => {
    setShowFilters((prev) => !prev);
  };

  const toggleOrder = () => {
    setOrderByRecent((prev) => !prev);
  };

  const toggleFiltersUnread = () => {
    setShowUnread((prev) => !prev);
  };
  const handleToggleShowAll = () => {
    setShowAllTickets((prev) => !prev);
  };

  useEffect(() => {

    setShowAllTickets(false);

  }, []);

  useEffect(() => {
    if (tab === "search") {
      searchInputRef.current.focus();
    }
  }, [tab]);

  const handleSearch = (e) => {
    const searchedTerm = e.target.value.toLowerCase();
    if (searchTimeout) clearTimeout(searchTimeout);

    if (searchedTerm === "") {
      setSearchParam("");
      setSearchMessage("");
      setTab("open");
      return;
    }

    searchTimeout = setTimeout(() => {
      if (searchMode === "message") {
        setSearchMessage(searchedTerm);
        setSearchParam("");
        setTab("search");
      } else {
        setSearchParam(searchedTerm);
        setSearchMessage("");
      }
    }, 300);
  };

  const toggleSearchMode = () => {
    setSearchMode((prev) => (prev === "message" ? "contact" : "message"));
    setSearchParam("");
    setSearchMessage("");
    if (searchInputRef.current) searchInputRef.current.value = "";
  };

  const handleChangeTab = (e, newValue) => {
    setTab(newValue);
  };

  const handleChangeTabOpen = (e, newValue) => {
    setTabOpen(newValue);
  };

  const applyPanelStyle = (status) => {
    if (tabOpen !== status) {
      return { width: 0, height: 0 };
    }
  };

  const handleCloseOrOpenTicket = (ticket) => {
    setNewTicketModalOpen(false);
    if (ticket !== undefined && ticket.uuid !== undefined) {
      navigate(`/tickets/${ticket.uuid}`);
    }
  };

  const handleSelectedTags = (selecteds) => {
    const tags = selecteds.map((t) => t.id);
    setSelectedTags(tags);
  };

  const handleSelectedUsers = (selecteds) => {
    const users = selecteds.map((t) => t.id);
    setSelectedUsers(users);
  };

  return (
    <Paper elevation={0} variant="outlined" className={classes.ticketsWrapper}>
      <NewTicketModal
        modalOpen={newTicketModalOpen}
        onClose={(ticket) => {
          handleCloseOrOpenTicket(ticket);
        }}
      />
      <Paper elevation={0} square className={classes.tabsHeader}>
        <Tabs
          value={tab}
          onChange={handleChangeTab}
          variant="fullWidth"
          indicatorColor="primary"
          textColor="primary"
          aria-label="icon label tabs example"
        >
          <Tab
            value={"open"}
            icon={<MoveToInboxIcon />}
            label={i18n.t("tickets.tabs.open.title")}
            classes={{ root: classes.tab }}
          />
          <Tab
            value={"closed"}
            icon={<CheckBoxIcon />}
            label={i18n.t("tickets.tabs.closed.title")}
            classes={{ root: classes.tab }}
          />
          <Tab
            value={"search"}
            icon={<SearchIcon />}
            label={i18n.t("tickets.tabs.search.title")}
            classes={{ root: classes.tab }}
          />
          <Tab
            value={"archived"}
            icon={<ArchiveIcon />}
            label={i18n.t("tickets.tabs.archived.title")}
            classes={{ root: classes.tab }}
          />
        </Tabs>
      </Paper>
      <Paper square elevation={0} className={classes.ticketOptionsBox}>
        <Grid container sx={{
          alignItems: "center"
        }}>
          <Grid size={7}>
            <div className={classes.searchInputWrapper}>
              <div className={classes.searchInputContainer}>
                <IconButton className={classes.iconButton} aria-label={i18n.t("tickets.search.ariaLabel")} size="large">
                  <SearchIcon fontSize="small" />
                </IconButton>
                <InputBase
                  className={classes.searchInput}
                  inputRef={searchInputRef}
                  placeholder={
                    searchMode === "message"
                      ? "Buscar por texto del mensaje…"
                      : i18n.t("tickets.search.placeholder")
                  }
                  type="search"
                  onChange={handleSearch}
                  inputProps={{ 'aria-label': i18n.t("tickets.search.ariaLabel") }}
                />
                {}
                <Tooltip
                  title={
                    searchMode === "message"
                      ? "Buscando en mensajes (abiertos y cerrados) — clic para buscar por contacto"
                      : "Buscando por contacto — clic para buscar dentro de los mensajes"
                  }
                >
                  <IconButton
                    className={classes.iconButton}
                    onClick={toggleSearchMode}
                    color={searchMode === "message" ? "primary" : "default"}
                    size="small"
                  >
                    {searchMode === "message" ? (
                      <ChatBubbleOutlineIcon fontSize="small" />
                    ) : (
                      <PersonSearchIcon fontSize="small" />
                    )}
                  </IconButton>
                </Tooltip>
              </div>
            </div>
          </Grid>

          <Grid>
            <Tooltip title={showFilters ? i18n.t("tickets.filters.hide") : i18n.t("tickets.filters.show")} arrow>
              <IconButton onClick={toggleFilters} size="large">
                <FilterListIcon
                  fontSize="small"
                  style={{
                    color: showFilters ? "#a13a3a" : "#838383",
                    transition: "color 0.3s"
                  }}
                />
              </IconButton>
            </Tooltip>
          </Grid>
          <Grid>
            <Tooltip title={showUnread ? i18n.t("tickets.unread.showAll") : i18n.t("tickets.unread.showUnreadOnly")} arrow>
              <IconButton onClick={toggleFiltersUnread} size="large">
                <FeedbackIcon
                  fontSize="small"
                  style={{
                    color: showUnread ? "#a13a3a" : "#838383",
                    transition: "color 0.3s"
                  }}
                />
              </IconButton>
            </Tooltip>
          </Grid>
          <Grid>
            <Tooltip title={orderByRecent ? "Ordenar: Más antiguos primero" : "Ordenar: Más recientes primero"} arrow>
              <IconButton onClick={toggleOrder} size="large">
                {orderByRecent ? (
                  <ArrowDownward style={{ color: "#a13a3a", transition: "color 0.3s" }} fontSize="small" />
                ) : (
                  <ArrowUpward style={{ color: "#838383", transition: "color 0.3s" }} fontSize="small" />
                )}
              </IconButton>
            </Tooltip>
          </Grid>
          {profile === "admin" && (
            <Grid>
              <Tooltip
                title={
                  exporting
                    ? "Exportando…"
                    : "Exportar a Excel los tickets de esta lista"
                }
                arrow
              >
                {}
                <span>
                  <IconButton
                    onClick={handleExport}
                    disabled={exporting}
                    size="large"
                  >
                    <FileDownloadIcon
                      fontSize="small"
                      style={{ color: exporting ? "#c9c9c9" : "#838383" }}
                    />
                  </IconButton>
                </span>
              </Tooltip>
            </Grid>
          )}

          <Grid size={12}>
            <Collapse in={showFilters}>
              <Grid container spacing={1} sx={{
                alignItems: "center"
              }}>
                <Grid
                  size={{
                    xs: 12,
                    sm: 6
                  }}>
                  <SelectConection
                    value={whatsappId}
                    onChange={values => setWhatsappId(values)}
                  />
                </Grid>
                <Grid
                  size={{
                    xs: 12,
                    sm: 6
                  }}>
                  <TicketsQueueSelect
                    selectedQueueIds={selectedQueueIds}
                    userQueues={user?.queues}
                    onChange={values => setSelectedQueueIds(values)}
                  />
                </Grid>
                <Grid
                  size={{
                    xs: 12,
                    sm: 6
                  }}>
                  <TagsFilter onFiltered={handleSelectedTags} />
                </Grid>
                <Grid
                  size={{
                    xs: 12,
                    sm: 6
                  }}>
                  {profile === "admin" && (
                    <UsersFilter onFiltered={handleSelectedUsers} />
                  )}
                </Grid>
                <Grid
                  size={{
                    xs: 12,
                    sm: 6
                  }}>
                  <SelectStatusContact selectId={selectedStatusId} onChange={values => setSelectedStatusId(values)} />
                </Grid>
                {campaignOptions.length > 0 && (
                  <Grid
                    size={{
                      xs: 12,
                      sm: 6
                    }}>
                    <FormControl fullWidth margin="dense" size="small">
                      <Select
                        fullWidth
                        displayEmpty
                        variant="outlined"
                        value={selectedCampaign}
                        onChange={(e) => setSelectedCampaign(e.target.value)}
                        renderValue={(val) => {
                          if (!val) return "Anuncio (Meta)";
                          const opt = campaignOptions.find(
                            (c) => c.adReferralSourceId === val
                          );
                          if (!opt) return "Anuncio";
                          const nombre =
                            opt.campaignName || opt.adReferralTitle || "Anuncio";
                          return opt.adReferralSource
                            ? `${opt.adReferralSource} · ${nombre}`
                            : nombre;
                        }}
                      >
                        <MenuItem value="">Todos los anuncios</MenuItem>
                        {campaignOptions.map((c) => (
                          <MenuItem key={c.adReferralSourceId} value={c.adReferralSourceId}>
                            {}
                            {c.adReferralSource ? (
                              <Chip
                                label={c.adReferralSource}
                                size="small"
                                sx={{ mr: 1, height: 20, fontSize: 11 }}
                              />
                            ) : null}
                            {c.campaignName || c.adReferralTitle || c.adReferralSourceId}
                            {c.count ? ` (${c.count})` : ""}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                )}
              </Grid>

            </Collapse>
          </Grid>
        </Grid>

      </Paper>
      <TabPanel value={tab} name="open" className={classes.ticketsWrapper}>
        <Tabs
          value={tabOpen}
          onChange={handleChangeTabOpen}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
        >
          {}
          <Tab
            icon={
              <Badge
                className={classes.badge}
                badgeContent={openCountFavorite}
                color="primary"
                max={99}
              >
                <Tooltip title={i18n.t("ticketsList.favoriteHeader")} arrow>
                  <PushPin className={classes.tabIcon} />
                </Tooltip>
              </Badge>
            }
            value={"favorite"}
            aria-label="Tickets Favoritos"
            className={classes.smallTab}
            style={{
              width: 64,
              maxWidth: 64
            }}
          />

          {}
          <Tab
            label={
              <Select
                value={showAllTickets ? "true" : "false"}
                onChange={(event) => setShowAllTickets(event.target.value === "true")}
                className={classes.select}
                variant="standard"
                disableUnderline
                MenuProps={{
                  disableAutoFocusItem: true,
                }}
                renderValue={(selected) => (
                  <div className={classes.tabLabelContent}>
                    {}
                    <Badge
                      className={classes.badge}
                      badgeContent={openCount}
                      color="primary"
                      max={999}
                    >
                      <Tooltip
                        title={selected === "true" ? i18n.t("tickets.allTickets") : i18n.t("tickets.myTickets")}
                        arrow
                      >
                        <MarkunreadIcon className={classes.tabIcon} />
                      </Tooltip>
                    </Badge>
                    <span className={classes.tabLabelText}>
                      {selected === "true" ? i18n.t("tickets.allTickets") : i18n.t("tickets.myTickets")}
                    </span>
                  </div>
                )}
              >
                <MenuItem value="true">{i18n.t("tickets.allTickets")}</MenuItem>
                <MenuItem value="false">{i18n.t("tickets.myTickets")}</MenuItem>
              </Select>
            }
            value={"open"}
            className={classes.expandableTab}
          />
          <Tab
            label={
              <div className={classes.tabLabelContent}>
                <Badge
                  className={classes.badge}
                  badgeContent={pendingCount}
                  color="primary"
                  max={999}
                >
                  <Tooltip title={i18n.t("ticketsList.pendingHeader")} arrow>
                    <AccessTimeIcon className={classes.tabIcon} />
                  </Tooltip>
                </Badge>
                <span className={classes.tabLabelText}>{i18n.t("ticketsList.pendingHeader")}</span>
              </div>
            }
            className={classes.expandableTab}
            value={"pending"}
          />

          {}
          {botCount > 0 && (
            <Tab
              className={classes.expandableTab}
              label={
                <div className={classes.tabLabelContent}>
                  <Badge
                    className={classes.badge}
                    badgeContent={botCount}
                    color="primary"
                    max={999}
                  >
                    <Tooltip title={i18n.t("ticketsList.botHeader")} arrow>
                      <RedditIcon className={classes.tabIcon} />
                    </Tooltip>
                  </Badge>
                  <span className={classes.tabLabelText}>Bot</span>
                </div>
              }
              value={"bot"}
            />
          )}

          {}
          {campaignCount > 0 && (
            <Tab
              className={classes.expandableTab}
              label={
                <div className={classes.tabLabelContent}>
                  <Badge
                    className={classes.badge}
                    badgeContent={campaignCount}
                    color="primary"
                    max={999}
                  >
                    <Tooltip title="Tickets que vinieron de un anuncio" arrow>
                      <CampaignOutlinedIcon className={classes.tabIcon} />
                    </Tooltip>
                  </Badge>
                  <span className={classes.tabLabelText}>Anuncios</span>
                </div>
              }
              value={"campaigns"}
            />
          )}
        </Tabs>

        <Paper className={classes.ticketsWrapper}>
          {}
          <TicketsList
            status="ads"
            showAll={showAllTickets}
            selectedQueueIds={selectedQueueIds}
            whatsappId={whatsappId}
            updateCount={(val) => setCampaignCount(val)}
            style={applyPanelStyle("campaigns")}
            tags={selectedTags}
            statusId={selectedStatusId}
            users={selectedUsers}
            searchParam={searchParam}
            orderByRecent={orderByRecent}
            adReferralSourceId={selectedCampaign}
          />
          <TicketsList
            status="favorite"
            selectedQueueIds={selectedQueueIds}
            whatsappId={whatsappId}
            updateCount={(val) => setOpenCountFavorite(val)}
            style={applyPanelStyle("favorite")}
            tags={selectedTags}
            searchParam={searchParam}
          />
          <TicketsList
            status="open"
            showAll={showAllTickets}
            selectedQueueIds={selectedQueueIds}
            whatsappId={whatsappId}
            updateCount={(val) => setOpenCount(val)}
            style={applyPanelStyle("open")}
            tags={selectedTags}
            statusId={selectedStatusId}
            users={selectedUsers}
            searchParam={searchParam}
            withUnreadMessages={showUnread}
            orderByRecent={orderByRecent}
            adReferralSourceId={selectedCampaign}
          />
          <TicketsList
            status="pending"
            selectedQueueIds={selectedQueueIds}
            whatsappId={whatsappId}
            updateCount={(val) => setPendingCount(val)}
            style={applyPanelStyle("pending")}
            tags={selectedTags}
            statusId={selectedStatusId}
            searchParam={searchParam}
            orderByRecent={orderByRecent}
            adReferralSourceId={selectedCampaign}
          />

          <TicketsList
            status="bot"
            selectedQueueIds={selectedQueueIds}
            whatsappId={whatsappId}
            updateCount={(val) => setBotCount(val)}
            style={applyPanelStyle("bot")}
            tags={selectedTags}
            statusId={selectedStatusId}
            searchParam={searchParam}
            orderByRecent={orderByRecent}
            adReferralSourceId={selectedCampaign}

          />

        </Paper>
        <Tooltip title={i18n.t("tickets.newConversation")} placement="right" arrow>
          <Fab
            size="medium"
            className={classes.fab}
            onClick={() => setNewTicketModalOpen(true)}
          >
            <WhatsApp />
          </Fab>
        </Tooltip>

      </TabPanel>
      <TabPanel value={tab} name="closed" className={classes.ticketsWrapper}>
        <TicketsList
          status="closed"
          showAll={true}
          usersLast={selectedUsers}
          selectedQueueIds={selectedQueueIds}
          updateCount={(val) => setClosedCount(val)}
          whatsappIdLast={whatsappId}
          tags={selectedTags}
          statusId={selectedStatusId}
          searchParam={searchParam}
          orderByRecent={orderByRecent}
          adReferralSourceId={selectedCampaign}
        />
      </TabPanel>
      <TabPanel value={tab} name="search" className={classes.ticketsWrapper}>

        <TicketsList
          searchParam={searchParam}
          searchMessage={searchMessage}
          showAll={true}
          tags={selectedTags}
          users={selectedUsers}
          whatsappId={whatsappId}
          selectedQueueIds={selectedQueueIds}
          orderByRecent={orderByRecent}
          adReferralSourceId={selectedCampaign}
          statusId={selectedStatusId}
        />
      </TabPanel>
      <TabPanel value={tab} name="archived" className={classes.ticketsWrapper}>
        <TicketsList
          archived="true"
          showAll={true}
          searchParam={searchParam}
          tags={selectedTags}
          users={selectedUsers}
          whatsappId={whatsappId}
          selectedQueueIds={selectedQueueIds}
          orderByRecent={orderByRecent}
          adReferralSourceId={selectedCampaign}
          statusId={selectedStatusId}
        />
      </TabPanel>
    </Paper >
  );
};

export default TicketsManagerTabs;
